import { useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { LocalOfferIcon, TwoWheelerIcon } from "../components/icons";
import toPriceDisplay from "../utils/toPriceDisplay";
import { selectStatefulCosts } from "../ducks/checkoutSlice";
import UnavailableDeliveryWarning from "../components/UnavailableDeliveryWarning";

const DeliveryLine = ({
  isSearchingLocation,
  deliveryError,
  deliveryPrice,
  searchedDelivery,
}) => {
  if (isSearchingLocation) {
    return (
      <p className="d-flex justify-content-between text-muted">
        <span>Entrega</span>
        <Spinner as="span" animation="border" size="sm" />
        <TwoWheelerIcon fontSize="small" />
      </p>
    );
  } else if (deliveryError) {
    return (
      <p className="d-flex justify-content-between text-muted">
        <span className="text-danger">
          <small>{deliveryError}</small>
        </span>
        <span className="text-danger">
          <TwoWheelerIcon fontSize="small" />
        </span>
      </p>
    );
  } else {
    return (
      <p className="d-flex justify-content-between text-muted">
        <span>
          Entrega
          {searchedDelivery.fee.estimatedMinutes
            ? ` (${searchedDelivery.fee.estimatedMinutes} min)`
            : ""}
        </span>
        <span className="text-muted">
          <TwoWheelerIcon fontSize="small" className="me-2" />
          {toPriceDisplay(deliveryPrice)}
        </span>
      </p>
    );
  }
};

const CouponLine = ({ couponError, isSearchingCoupon, discount }) => {
  if (isSearchingCoupon) {
    return (
      <p className="d-flex justify-content-between text-muted">
        <span>Cupom</span>
        <Spinner as="span" animation="border" size="sm" />
        <LocalOfferIcon fontSize="small" />
      </p>
    );
  } else if (couponError) {
    return (
      <p className="d-flex justify-content-between text-muted">
        <span className="text-danger">
          <small>{couponError}</small>
        </span>
        <span className="text-danger">
          <LocalOfferIcon fontSize="small" />
        </span>
      </p>
    );
  } else {
    return (
      <p className="d-flex justify-content-between text-muted">
        <span>Cupom</span>
        <span className="text-success">
          <LocalOfferIcon fontSize="small" className="me-2" />-
          {toPriceDisplay(discount)}
        </span>
      </p>
    );
  }
};

export default function CheckoutCosts() {
  const {
    searchedDelivery,
    toDelivery,
    isSearchingLocation,
    isSearchingCoupon,
    coupon,
  } = useSelector((state) => state.checkout);
  const costs = useSelector(selectStatefulCosts);

  return (
    <div className="checkout-costs">
      {costs.showSubtotal && (
        <p className="d-flex justify-content-between text-muted">
          <span>Subtotal</span>
          <span>{toPriceDisplay(costs.subtotal)}</span>
        </p>
      )}

      {toDelivery && (
        <DeliveryLine
          isSearchingLocation={isSearchingLocation}
          deliveryError={costs.deliveryError}
          deliveryPrice={costs.delivery}
          searchedDelivery={searchedDelivery}
        />
      )}

      {coupon && (
        <CouponLine
          isSearchingCoupon={isSearchingCoupon}
          couponError={costs.couponError}
          discount={costs.discount}
        />
      )}

      {costs.hasTakeoutDiscount && (
        <p className="d-flex justify-content-between text-muted">
          <span>Desconto para retirar</span>
          <span className="text-success">
            <LocalOfferIcon fontSize="small" className="me-2" />-
            {toPriceDisplay(costs.takeoutDiscount)}
          </span>
        </p>
      )}

      {costs.fidelityDiscount && (
        <p className="d-flex justify-content-between text-muted">
          <span>Desconto fidelidade</span>
          <span className="text-success">
            <LocalOfferIcon fontSize="small" className="me-2" />-
            {toPriceDisplay(costs.fidelityDiscount)}
          </span>
        </p>
      )}

      <p className="d-flex justify-content-between fw-bold checkout-costs__total">
        <span>Total</span>
        <span>{toPriceDisplay(costs.total)}</span>
      </p>

      <UnavailableDeliveryWarning />
    </div>
  );
}
